import { Port } from '../../maritime-menu-options/world-ports-panel/world-ports.model';
import { ProReportResponse } from '../../models/pro.model';
import DateTimeHelpers from '../../utils/date-time-helpers.utils';
import ProReportEmailClubContact from './pro-report-email-components/pro-report-email-club-contact';
import { Spacer } from './pro-report-email-components/pro-report-email-common-components';
import ProReportEmailCorrespondentAdvice from './pro-report-email-components/pro-report-email-correspondent-advice';
import ProReportEmailCorrespondentContact from './pro-report-email-components/pro-report-email-correspondent-contact';
import ProReportEmailDestinationPort from './pro-report-email-components/pro-report-email-destination-port';
import ProReportEmailFirstCallInfo from './pro-report-email-components/pro-report-email-first-call-info';
import ProReportEmailFooter from './pro-report-email-components/pro-report-email-footer';
import ProReportEmailHeading from './pro-report-email-components/pro-report-email-heading';
import ProReportEmailLossPreventionCommentary from './pro-report-email-components/pro-report-email-loss-prevention-commentary';
import ProReportEmailNoDataPlaceHolder from './pro-report-email-components/pro-report-email-no-data';
import ProReportRiskTable from './pro-report-email-components/pro-report-email-risk-table';
import ProReportEmailSecurityAdvice from './pro-report-email-components/pro-report-email-security-advice';
import ProReportEmailFeedback from './pro-report-email-components/pro-report-feedback';
import { getRiskTableData } from './pro-report-email-export-helpers';
import {
  emailDefaultBackgroundColour,
  emailDefaultTextColour,
  emailFontFamily,
} from './pro-report-email-styles';

const currentDateTimeUTC: string = DateTimeHelpers.getCurrentUtcDateTime();

function ProReportEmail({
  report,
  port,
}: {
  report: ProReportResponse;
  port: Port;
}) {
  if (!report || !port) {
    return (
      <html dir="ltr" lang="en">
        <head />
        <body>
          <table
            style={{
              backgroundColor: emailDefaultBackgroundColour,
              padding: '20px',
              borderRadius: '8px',
              color: emailDefaultTextColour,
              fontFamily: emailFontFamily,
            }}
            role="presentation"
          >
            <ProReportEmailHeading utcDateString={currentDateTimeUTC} />
            <br />
            <ProReportEmailNoDataPlaceHolder
              header="Report Not Available"
              subHeading="Message"
              content="No data is available for this report."
            />
            <br />
            <ProReportEmailCorrespondentContact />
            <br />
            <ProReportEmailClubContact />
            <br />
            <ProReportEmailFooter />
            <br />
          </table>
        </body>
      </html>
    );
  }

  const portRiskTableData = getRiskTableData({ report });
  const claimsAdvice = report.claims_advice ?? [];
  const correspondentAdvice = report.correspondent_advice ?? null;
  const securityAdvice = report.security_advice ?? null;
  const firstCallInfo = report.first_call_info ?? null;
  const correspondentContact = report.correspondent_contact ?? null;

  let correspondentDescription = null;
  if (correspondentContact) {
    const { name } = correspondentContact;
    const { company } = correspondentContact;
    if (name && company) {
      correspondentDescription = `${name} (${company})`;
    } else if (name) {
      correspondentDescription = name;
    } else if (company) {
      correspondentDescription = company;
    }
  }

  return (
    <html dir="ltr" lang="en">
      <head />
      <body>
        <table
          style={{
            backgroundColor: emailDefaultBackgroundColour,
            padding: '20px',
            borderRadius: '8px',
            color: emailDefaultTextColour,
            fontFamily: emailFontFamily,
          }}
          role="presentation"
        >
          <ProReportEmailHeading utcDateString={currentDateTimeUTC} />
          <Spacer />
          <ProReportEmailDestinationPort port={port} />
          <Spacer />
          <ProReportRiskTable riskTableData={portRiskTableData} />
          <Spacer />
          <ProReportEmailLossPreventionCommentary claimsAdvice={claimsAdvice} />
          <Spacer />
          <ProReportEmailCorrespondentAdvice
            correspondentAdvice={correspondentAdvice}
            correspondentDescription={correspondentDescription}
          />
          <Spacer />
          <ProReportEmailSecurityAdvice securityAdvice={securityAdvice} />
          {/* Spacer added by Security Advice Info if present */}
          <ProReportEmailCorrespondentContact
            correspondentContact={correspondentContact}
          />
          <Spacer />
          <ProReportEmailFirstCallInfo firstCallInfo={firstCallInfo} />
          {/* Spacer added by First Call Info if present */}
          <ProReportEmailClubContact />
          <Spacer />
          <ProReportEmailFeedback />
          <Spacer />
          <ProReportEmailFooter />
          <Spacer />
        </table>
      </body>
    </html>
  );
}

export default ProReportEmail;
